/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Keyword_PerInputs */

const en_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per keyword`)
};

const zh_hans1_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个关键词`)
};

const pt_br2_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por palavra-chave`)
};

const es_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por palabra clave`)
};

const fr_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par mot-clé`)
};

const de_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Keyword`)
};

const ru_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за ключевое слово`)
};

const it_measure_unit_keyword_per = /** @type {(inputs: Measure_Unit_Keyword_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per parola chiave`)
};

/**
* | output |
* | --- |
* | "per keyword" |
*
* @param {Measure_Unit_Keyword_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_keyword_per = /** @type {((inputs?: Measure_Unit_Keyword_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Keyword_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_keyword_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_keyword_per(inputs)
	if (locale === "es") return es_measure_unit_keyword_per(inputs)
	if (locale === "fr") return fr_measure_unit_keyword_per(inputs)
	if (locale === "de") return de_measure_unit_keyword_per(inputs)
	if (locale === "ru") return ru_measure_unit_keyword_per(inputs)
	if (locale === "it") return it_measure_unit_keyword_per(inputs)
	return en_measure_unit_keyword_per(inputs)
});